import { useEffect } from 'react';

export const useLingualTextLanguageSelectorMutator = (
    lingualFieldSelectionMutator: (...args: any[]) => any
) => {
    useEffect(() => {
        lingualFieldSelectionMutator();
    }, [lingualFieldSelectionMutator]);
};
